class CustomerLogin {
  constructor() {
    this.init();
  }

  init() {
    const url = new URL(window.location.href)
	  let reset = url.searchParams.get('reset')
    if(reset === 'true') {
      document.querySelector('[data-reset-message]').classList.remove('hidden')
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new CustomerLogin();
});
